import * as React from 'react';
import { Field } from 'redux-form';
import { Col, ControlLabel, FormGroup, Grid, OverlayTrigger, Popover, Row } from 'react-bootstrap';
import { II18nMessages } from '../../../../../../services/branding/models';
import { renderProductDefinition } from '../../../MakeAChange/Helpers';
import { IProduct } from '../../../../../../data/api/models';
import { map } from 'lodash';
import * as Commonmark from 'react-commonmark';
import { FaQuestionCircle } from 'react-icons/fa';
import SelectControl from '../../../../../../components/SelectControl';
import { isRequired } from '../../../../../../util/validators';
import { IQuoteActions } from '../../../../../../services/quote/models';
import { RenewalSubmitButton } from '../RenewalSubmitButton';
import { MTACardHeader } from '../../../MakeAChange/components/CoverDetails/scenes/Components/MTACardHeader';

interface ChangeRegionProps {
  product: IProduct;
  i18n: II18nMessages;
  region: string;
  dispatch: any;
  change: any;
  loading: boolean;
  actions: {
    quote: IQuoteActions;
  };
  goBackButton: any;
  onSubmit: () => any;
}

class ChangeRegion extends React.Component<ChangeRegionProps, any> {

  constructor(props) {
    super(props);
    this.state = {
      region: null,
    }
  }

  private onchangeRegion = (event: any, region: string): void => {
    const { actions } = this.props;
    this.setState({ region })
    actions.quote.recalculateScreening(null, true, region);
  }

  private onSubmitChanges = () => {
    const { change, onSubmit } = this.props;
    const { region } = this.state;
    Promise.resolve(change('region', region)).then(() => {
      onSubmit()
    })
  }

  render() {
    const { i18n, product, loading, goBackButton } = this.props;
    const { region } = this.state;
    const renderDefinition = renderProductDefinition(product);

    const popoverClickRootClose = (
      <Popover id="popover-trigger-click-root-close" title="Regions">
        <Commonmark source={product.metadata.definitions.region_uk}/>
        <Commonmark source={product.metadata.definitions.region_europe}/>
        <Commonmark source={product.metadata.definitions.region_worldwide_excluding}/>
        <Commonmark source={product.metadata.definitions.region_worldwide}
        />
      </Popover>
    );

    const regionsList = map(product.metadata.regions, (name, key) => {
      return {
        label: name,
        value: key,
      };
    });

    return (
      <>
        <div className="admiral-card mt-30">
          <MTACardHeader text={'Please answer the following questions.'}/>
          <div className="body">
            <Grid fluid={true}>
              <div>
                <p
                  style={{ marginTop: '20px' }}>{'Please select or type your updated destination below'} {renderDefinition('region')}</p>
                <Row className="margin-top dynamic-row">
                  <Col sm={12}>
                    <FormGroup controlId="destination">
                      <Col componentClass={ControlLabel} sm={6}>
                        {i18n.quote.tripDetails.region}{' '}
                        <OverlayTrigger
                          trigger="click"
                          rootClose={true}
                          placement="right"
                          overlay={popoverClickRootClose}
                        ><FaQuestionCircle className="info-btn"/>
                        </OverlayTrigger>
                      </Col>
                      <Col sm={6} className="destinations-inputs">
                        <Field
                          id="destinations-inputs"
                          type="text"
                          component={SelectControl}
                          onChange={this.onchangeRegion}
                          forceFilter={false}
                          options={regionsList}
                          validate={[
                            isRequired,
                          ]}
                        /></Col>
                    </FormGroup>
                    <div className="info-note">
                      {i18n.quote.tripDetails.europeanIncluded}{' '}
                    </div>
                  </Col>
                </Row>
              </div>
              <div className={'renewal-edit-form-buttons'} style={{ marginBottom: '20px' }}>
                <div className={'renewal-go-back-button'}>
                  {goBackButton}
                </div>
                <div className={'renewal-submit-button'}>
                  <RenewalSubmitButton
                    isLoading={loading}
                    disabled={!region}
                    onSubmit={this.onSubmitChanges}
                  />
                </div>
              </div>
            </Grid>
          </div>
        </div>
      </>
    )
  }
}

export default ChangeRegion;
